import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './funcional.css';

// Estilos inline para o componente de vídeo
const videoStyles = {
    container: {
        margin: '20px 0',
    },
    videoWrapper: {
        position: 'relative',
        paddingBottom: '56.25%', // Proporção 16:9
        height: 0,
        overflow: 'hidden',
        maxWidth: '100%',
        background: '#000',
        borderRadius: '8px',
    },
    video: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    }
};

const Funcional = () => {
    const [dailyContent, setDailyContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDailyContent = async () => {
            try {
                const userIdentifier = localStorage.getItem('userEmail');
                const token = localStorage.getItem('token');
                
                if (!userIdentifier) {
                    throw new Error('Usuário não identificado. Faça login novamente.');
                }
                
                const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
                const response = await axios.get(`${apiUrl}/api/cronogramas/dia/${userIdentifier}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setDailyContent(response.data);
                setLoading(false);
            } catch (err) {
                console.error('Erro ao buscar conteúdo funcional:', err);
                setError(err);
                setLoading(false);
            }
        };

        fetchDailyContent();
    }, []);

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>Erro ao carregar conteúdo funcional</div>;

    const videos = dailyContent?.funcional?.videos || [];

    return (
        <div className="Fcontainer">
            <header className="Fheader">
                <h1 className="Ftext-3xl font-bold text-white text-center">Funcional</h1>
                <p className="Ftext-lg text-white text-center">{new Date().toLocaleDateString()}</p>
            </header>

            <div className="Fcard">
                <h2 className="Ftext-xl font-semibold mb-4">Vídeos do Dia</h2>
                {videos.length > 0 ? (
                    <div className="video-list">
                        {videos.map((videoUrl, index) => (
                            <div key={index} className="video-item" style={{ marginBottom: '2rem' }}>
                                <h3 className="text-lg font-medium mb-2">Vídeo {index + 1}</h3>
                                <div style={videoStyles.videoWrapper}>
                                    <video 
                                        controls 
                                        style={videoStyles.video}
                                        preload="metadata"
                                    >
                                        <source src={videoUrl} type="video/mp4" />
                                        Seu navegador não suporta a reprodução de vídeos.
                                    </video>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>Sem vídeos disponíveis para hoje</p>
                )}
            </div>
        </div>
    );
};

export default Funcional;
